"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenSection = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
let TokenSection = class TokenSection extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.description = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-text-block
        level="2"
        heading=${this.heading}
        description=${this.description}
      ></mm-text-block>
      <slot></slot>
    `;
    }
};
TokenSection.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-6);
    }

    slot {
      display: flex;
      flex-direction: column;
      gap: var(--space-4);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TokenSection.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TokenSection.prototype, "description", void 0);
TokenSection = __decorate([
    (0, decorators_js_1.customElement)('mm-token-section')
], TokenSection);
exports.TokenSection = TokenSection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4tc2VjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRva2VuLXNlY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCwrQkFBNEI7QUFHckIsSUFBTSxZQUFZLEdBQWxCLE1BQU0sWUFBYSxTQUFRLGdCQUFVO0lBQXJDOztRQWN1QixZQUFPLEdBQUcsRUFBRSxDQUFBO1FBQ1osZ0JBQVcsR0FBRyxFQUFFLENBQUE7SUFZOUMsQ0FBQztJQVZDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7a0JBR0csSUFBSSxDQUFDLE9BQU87c0JBQ1IsSUFBSSxDQUFDLFdBQVc7OztLQUdqQyxDQUFBO0lBQ0gsQ0FBQzs7QUF6Qk0sbUJBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7O0dBWWxCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzZDQUFhO0FBQ1o7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2lEQUFpQjtBQWZqQyxZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxrQkFBa0IsQ0FBQztHQUNyQixZQUFZLENBMkJ4QjtBQTNCWSxvQ0FBWSJ9